"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.PropertiesSelectorContainer = void 0;
var container_1 = require("./container");
Object.defineProperty(exports, "PropertiesSelectorContainer", { enumerable: true, get: function () { return container_1.PropertiesSelectorContainer; } });
var reducer_1 = require("./reducer");
Object.defineProperty(exports, "reducer", { enumerable: true, get: function () { return reducer_1.reducer; } });
//# sourceMappingURL=index.js.map